import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Floor
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.setGeometry()
        this.setTextures()
        this.setMaterial()
        this.setMesh()
        this.setShadowMesh()
        this.update(0)
    }

    setGeometry()
    {
        this.geometry = new THREE.PlaneGeometry(1, 1)
    }

    setTextures()
    {
        this.textures = {}

        this.textures.color = this.resources.items.cloudsColorTexture
        this.textures.color.colorSpace = THREE.SRGBColorSpace
        this.textures.alpha = this.resources.items.cloudsAlphaTexture
        this.textures.simpleShadow = this.resources.items.marioShadowTexture
    }

    setMaterial()
    {
        this.material = new THREE.MeshStandardMaterial({
            map: this.textures.color,
            alphaMap: this.textures.alpha,
            transparent: true
        })

        this.shadowsMaterial = new THREE.MeshBasicMaterial({
            color: 'black',
            transparent: true,
            opacity: 0.3,
            alphaMap: this.textures.simpleShadow
        })
    }

    setMesh()
    {
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        //this.mesh.rotation.y = - Math.PI
        this.mesh.castShadow = true

        this.scene.add(this.mesh)
    }

    setShadowMesh()
    {
        this.shadowMesh = new THREE.Mesh(
            new THREE.PlaneGeometry(1, 1, 4),
            this.shadowsMaterial
        )
        this.shadowMesh.scale.set(1, 1, 0.5)
        this.shadowMesh.position.y = this.experience.world.floor.mesh.position.y + 0.01
        this.shadowMesh.rotation.x = -Math.PI * 0.5
        this.scene.add(this.shadowMesh)
    }

    setPosition(...args)
    {
        this.mesh.position.set(...args)
        this.update(0)
    }

    update(time)
    {
        // this.shadowMesh.position.set(this.mesh.position)
        this.shadowMesh.position.x = this.mesh.position.x - 1
        this.shadowMesh.position.z = this.mesh.position.z - 1
        this.shadowMesh.position.y = this.experience.world.floor.mesh.position.y + 0.01

        // modify opacity of the shadow based on the sphere Y position
        this.shadowMesh.material.opacity = THREE.MathUtils.mapLinear(this.mesh.position.y, 0, 5, 0.5, 0.1)
    }
}